module.exports = __webpack_public_path__ + "img/Iceberg_Logo.9606a0cb.png";